import { render, staticRenderFns } from "./singleProduct.vue?vue&type=template&id=840aecc8&scoped=true&"
import script from "./singleProduct.vue?vue&type=script&lang=js&"
export * from "./singleProduct.vue?vue&type=script&lang=js&"
import style0 from "./singleProduct.vue?vue&type=style&index=0&id=840aecc8&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "840aecc8",
  null
  
)

export default component.exports